"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllIntegrationsCatalogClient = void 0;
const new_crud_client_1 = require("./new.crud.client");
class AllIntegrationsCatalogClient extends new_crud_client_1.NewCrudClient {
    constructor() {
        super(...arguments);
        this.version = 'v1';
        this.entityPath = 'all-integrations-catalog';
    }
}
exports.AllIntegrationsCatalogClient = AllIntegrationsCatalogClient;
//# sourceMappingURL=all-integrations-catalog.client.js.map